module.exports = __webpack_public_path__ + "img/h5-service-maker.87227dae.png";